import { IDeleteCentroCustoByIdUseCase } from "../../../presentation/useCases/delete/delete_centro_custo_use_case";
import { ErrorsList } from "../../models/erros_list";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * DeleteCentroCustoUseCase
 */

export class DeleteCentroCustoByIdUseCase implements IDeleteCentroCustoByIdUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async deleteCentroCustoById(idCentroCusto: number): Promise<ErrorsList> {
    const erros = await this.repository.deleteCentroCustoById(idCentroCusto);
    return erros;

  }

}
